export default __webpack_public_path__ + "static/banner-3-b74a6c2fcd0e50a8e48a61b9276bcbce.png";